import {Icon} from './Icon';

export type InstallPlatform='ios'|'android';

export function getInstallPlatform():InstallPlatform|null {
  const agent=navigator.userAgent;
  if(/iPhone|iPod/i.test(agent))return 'ios';
  if(/Android/i.test(agent)&&/Mobile/i.test(agent))return 'android';
  return null;
}

export function isStandalone():boolean {
  const iosNavigator=navigator as Navigator&{standalone?:boolean};
  return iosNavigator.standalone===true||['standalone','minimal-ui','fullscreen'].some(mode=>window.matchMedia?.(`(display-mode: ${mode})`).matches)||document.referrer.startsWith('android-app://');
}

export function InstallInstructions({platform}:{platform:InstallPlatform|null}) {
  if(platform==='android')return <ol className="install-steps"><li>Apri il menu del browser, di solito con i tre puntini.</li><li>Tocca “Installa app” oppure “Aggiungi a schermata Home” e conferma.</li></ol>;
  if(platform==='ios')return <ol className="install-steps"><li>Apri Codalia in Safari e tocca il pulsante Condividi.</li><li>Scegli “Aggiungi alla schermata Home” e poi “Aggiungi”.</li></ol>;
  return <p>Su iPhone apri Codalia in Safari, tocca Condividi e scegli “Aggiungi alla schermata Home”. Su Android apri il menu del browser e scegli “Installa app” o “Aggiungi a schermata Home”.</p>;
}

export function InstallGuide({open,platform,onClose}:{open:boolean;platform:InstallPlatform;onClose:()=>void}) {
  return <section id="install-guide" className="install-guide" aria-labelledby="install-guide-title" hidden={!open}>
    <div className="install-guide-heading"><div><h2 id="install-guide-title">Aggiungi Codalia alla schermata Home</h2><p>Aprila rapidamente, come un’app.</p></div><button type="button" className="icon-button install-guide-close" onClick={onClose} aria-label="Chiudi istruzioni di installazione"><Icon name="close"/></button></div>
    <InstallInstructions platform={platform}/>
    <p className="install-offline-note">Per l’uso senza rete, attendi “Disponibile offline”.</p>
  </section>;
}
